import ApiService from './api.service'

const SignupService = {

  /***
   * Create an ezSignup submission
   * @param {object} params.selectedPlan values from the selectedPlan section
   * @param {object} params.accountHolder values from the accountHolder section
   * @param {object} params.location values from the location section
   * @param {object} params.locationMarker values from the locationMarker section
   * @param {object} params.billingHolder values from the billingHolder section
   * @param {object} params.questionnaireValues values from the questionnaire section
   * @param {object} params.addonValues values from the addon section
   * @returns {*}
   */
  ezSignup (params) {
    return ApiService.post('signup/ez-signup', params)
  },
  /***
   * Create a signup as a staff member
   * @param {string} params.form_data.firstName
   * @param {string} params.form_data.lastName
   * @param {string} params.form_data.email
   * @param {string} params.form_data.phone
   * @param {string} params.form_data.comment
   * @param {integer} params.form_data.storeid
   * @param {string} params.location_key rowkey of location
   * @returns {*}
   */
  staffSignup (params) {
    return ApiService.post('signup/staff-signup', params)
  },
  /***
   * Create an ezSignup submission
   * @param {string} slug rowkey of the signup to check

   * @returns {*}
   */
  checkStatus (slug) {
    return ApiService.postAction('signup', slug, 'check', {})
  },
  /***
   * Create an ezSignup submission
   * @param {string} slug rowkey of the signup to check
   * @returns {*}
   */
  confirm (slug) {
    return ApiService.postAction('signup', slug, 'confirm', {})
  },
  /***
   * Confirm a VW form signup
   * @param {string} slug rowkey of the signup to confirm
   * @returns {*}
   */
  vwConfirm (slug) {
    return ApiService.postAction('signup', slug, 'vw-confirm', {})
  },
}
export default SignupService
